<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="60px">
				<el-row>
					<el-col :span="3">
						<el-form-item>
							<el-select @change="list" v-model="searchParams.tnm">
								<el-option v-for="(itm, idx) in ['答题统计', '成绩分析', '试卷情况', '合并答案']" :key="idx"
									:label="itm" :value="idx">
								</el-option>
							</el-select>

						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="!searchParams.tnm && (searchParams.tnm < 3)">
						<el-form-item label="科目">
							<el-input placeholder="科目" disabled v-model="sbname">
								<template slot="append">
									<el-button type="primary" @click="selectSub()">请选择科目</el-button>
								</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="3" v-if="searchParams.tnm < 3">
						<el-form-item label="班级">
							<el-autocomplete class="inline-input" v-model="searchParams.clz"
								:fetch-suggestions="querySearch" placeholder="请输入班级名称"
								@select="handleSelect"></el-autocomplete>
						</el-form-item>
					</el-col>


					<el-col :span="7" v-if="searchParams.tnm < 3">
						<el-form-item label="学生">
							<div v-if="stuList && stuList.length > 0"
								style="display: flex;margin-top:4px; margin-left:10px">

								<el-button type="success" :disabled="stuIdx == 0" size="mini"
									@click="naviStu(-1)">《《</el-button>
								<el-select @change="handleStuSelect" v-model="searchParams.snm" placeholder="请选择">
									<el-option v-for="item in stuList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
								<el-button type="success" :disabled="stuIdx == (stuList.length - 1)" size="mini"
									@click="naviStu(1)">》》
								</el-button>
							</div>
							<el-input v-else placeholder="学生" v-model="searchParams.snm">
							</el-input>
						</el-form-item>
					</el-col>
					<!-- el-col :span="4" v-show="searchParams.clz" v-if="!searchParams.tnm">
						<el-form-item label="考试">
							<el-input placeholder="请输入班级-考试" v-model="searchParams.exm">
							</el-input>
						</el-form-item>
					</el-col  -->
					<el-col :span="5" v-if="searchParams.tnm != 1 && searchParams.tnm < 3">
						<div class="search-btn">
							<el-checkbox @change="list" v-if="searchParams.tnm != 2"
								v-model="isSortByScore">成绩排序</el-checkbox>
							<el-checkbox @change="handleGroupOrderSort" v-if="searchParams.tnm == 2"
								v-model="isSortByGroupOrder">分组序号排序</el-checkbox>
							<el-button type="primary" @click="list">搜索</el-button>
							<el-button @click="clearSearchVal">清空</el-button>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<div v-if="selected.length > 0"><el-button type="danger" v-if="searchParams.snm" size="mini"
					@click="toBukao()">个人补考</el-button> {{ msg }} </div>
		</div>

		<div class="dataTable autoFlex" v-if="listData">

			<el-table class="table" v-if="searchParams.tnm == 2" stripe :data="sortedListData" border height="auto"
				v-loading="listLoading">

				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="subjectName" label="科目名称" width="200">
					<template slot-scope="scope">
						<span>{{ getSubjectName(scope.row.subId) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="exmtm" width="140" label="考试时间">
					<template slot-scope="scope">
						<el-tag size="mini" type="danger">{{ (scope.row.type == 2 && scope.row.type == 4) ?
							scope.row.exmtm : scope.row.crtm }} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="name" width="300" label="考试名称"></el-table-column>
				<el-table-column prop="exampName" label="试 卷"></el-table-column>




				<el-table-column prop="type" width="100" label="考试类型">
					<template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.type == 1" size="mini">线下考试
						</el-tag>
						<el-tag type="warning" v-else-if="scope.row.type == 2" size="mini">竞赛问答
						</el-tag>
						<el-tag type="warning" v-else-if="scope.row.type == 3" size="mini">作业
						</el-tag>
						<el-tag type="danger" v-else-if="scope.row.type == 4" size="mini">问答轮询
						</el-tag>
						<el-tag type="success" v-else size="mini">线上 </el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="score" width="130" label="得分">

				</el-table-column>
				<el-table-column prop="pgStu" width="130" label="判卷">
					<template slot-scope="scope">
						<el-tag size="mini" type="success">{{ showPger(scope.row) }} </el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="exmtm" width="130" label="批改时间">
					<template slot-scope="scope">
						<el-tag size="mini" type="success">{{ scope.row.exmtm ? scope.row.exmtm :
							scope.row.mdtm }} </el-tag>
					</template>
				</el-table-column>


			</el-table>

			<div class="dataTable autoFlex" v-else-if="searchParams.tnm == 1">
				<el-row>
					<el-col :span="24">
						<div id="rpt1" style="width:100%;height:520px;">12121</div>
					</el-col>
				</el-row>
			</div>

			<el-table class="table" v-else :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">

				<el-table-column type="selection" width="55" fixed="left"></el-table-column>

				<el-table-column prop="sbname" width="250" label="科目名称"></el-table-column>
				<el-table-column prop="qnm" label="试题名称"></el-table-column>

				<el-table-column prop="type" width="90" label="试题类型">
					<template slot-scope="scope">
						<span>{{ scope.row.type }}</span>
					</template>
				</el-table-column>

				<el-table-column prop="cnt" width="90" label="出题次数"></el-table-column>

				<el-table-column prop="rrate" width="130" label="正确率%">
					<template slot-scope="scope">
						<el-tag size="mini" type="danger">{{ scope.row.exmtm }} </el-tag>
						{{ scope.row.rrate }}
					</template>
				</el-table-column>
				<el-table-column fixed="right" width="120px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button v-has-permission-code-and="'0040002000500005'" size="mini" icon="el-icon-search"
								@click="toDetail(scope.$index, scope.row)">详情</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<el-dialog title="选择科目" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
				<tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList"
					:data="permissionList" :defaultParent="0" @nodeClick="treeClick" :expand-on-click-node="true">
				</tree>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="comfirmSub">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="补考安排" :visible.sync="dialogVisible2" width="40%" :append-to-body="true">
				<div>
					<el-row>
						<el-col :span="4">
							考试时间
						</el-col>
						<el-col :span="16">
							<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="bukaoTm" type="datetimerange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</el-col>
					</el-row> <el-row>
						<el-col :span="4">
							考试时长
						</el-col>
						<el-col :span="16">
							<el-input placeholder="单位分钟" v-model="bukao.duration">
							</el-input>
						</el-col>
					</el-row>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible2 = false">取 消</el-button>
					<el-button type="primary" @click="comfirmBuKao">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 分页导航栏 -->
			<div class="pageBar" v-if="searchParams.tnm != 1">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>

		</div>
		<div class="dataTable autoFlex" v-else>
			<el-row>
				<el-col :span="24" id="rpt1_p">
					<div id="rpt1" style="width:88%;height: 500px;">准备显示..</div>
				</el-col>
			</el-row>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>

import edit from './edit.vue';
import api from '@/api/exams/exams/rpt_answers.js';
import subApi from "@/api/edu/subject/subject.js";
import subStu from "@/api/stus/student/student.js";
import apiExm from '@/api/exams/exams/exams.js';
import * as echarts from 'echarts';
import apiClazz from '@/api/edu/clazz/clazz.js';
import apiCour from '@/api/exams/exampaper/exampaper.js';
import tree from "@/components/tree/tree.vue";

export default {
	name: 'rptAnswers',
	components: {
		edit,
		tree,
		echarts
	},
	watch: {
		'searchParams.clz': {
			handler(newVal) {
				if (!newVal) {
					this.searchParams.exm = ''
				}
			},
			deep: true
		}
	},
	data() {
		return {
			exampaperDataMap: new Map(),
			subjectNameMap: new Map(),
			searchParams: { tnm: 0 },
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			sortedListData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			sbname : undefined,

			options: [],
			option: '',
			dialogVisible: false,
			tableData: [],

			scoreAll: 0,// 总得分
			scorate: 0,//正确率
			unScora: 0,//错误率
			permissionList: [],
			stuList: [],
			stuIdx: 0,       //当前显示的学生
			clzList: null,  //备选班级
			subData: [],
			isSortByScore: false,
			isSortByGroupOrder: false, // 分组序号排序
			msg: "",

			dialogVisible2: false,   //补考弹框
			bukaoTm: [],//补考时间
			bukao: { duration: 120 },  //补考

			examCnt: 0,
			echart1: {},     //图表
			isAddon: false,   //是否已添加事件
			option: {
				title: {
					text: ''
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				legend: {},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'value',
					boundaryGap: [0, 0.01],
					max: 100
				},
				yAxis: {
					type: 'category',
					//data: ['前端基础[156题]', 'Java核心编程', '数据库开发', 'JavaWeb开发',
					//	'前端框架', 'Java开源框架', 'SpringCloud微服务[156题]', '软件工程', '项目开发阶段']
				},
				series: [
					{
						name: '得分比',
						type: 'bar',
						//data: [76, 63, 72, 56, 25, 56, 87, 98, 100],
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									textStyle: { //数值样式
										color: "#fff",
										fontSize: 20,
										fontWeight: 400
									}
								},
								//可以设置每个柱上方显示数字
								color: function (params) {//柱状图设置不同颜色
									// 给出颜色组
									if (params.data < 60) {
										return "#ee6767";
									} else if (params.data < 75) {
										return "#4a77dd";
									} else if (params.data < 85) {
										return "#fac859";
									} else {
										return "#92cc76";
									}
								},
							}
						}
					},
				]
			}
		};
	},

	methods: {

		naviStu(val) {
			//学生导航
			if (this.stuList && this.stuList.length > 0) {
				//计算新的索引
				let newIdx = this.stuIdx + val;

				//确保索引在有效范围内
				if (newIdx >= 0 && newIdx < this.stuList.length) {
					this.stuIdx = newIdx;
					this.searchParams.snm = this.stuList[this.stuIdx];
					this.list();
				}
			}
		},
		showPger(row) {

			if (row.type * 1 == 4) {
				return row.pgStu
			} else {
				if (row.pgTr) {
					return row.pgTr
				}
			}
			return '自动判卷'

		},

		// 备选班级
		querySearch(queryString, cb) {
			// console.log("this.clzList",this.clzList)
			if (this.clzList) {
				cb(this.clzList);
			}

		},
		// 选中班级
		handleSelect(item) {
			//console.log("选中班级",item)
			this.loadStu()
		},

		loadStu() {
			//console.log("失去焦点" )
			subStu.stuInClass2({ cname: this.searchParams.clz }, res => {
				this.stuList = res.data

				//如果有学生
				if (this.stuList && this.stuList.length > 0) {
					//默认查询第一个学生
					this.searchParams.snm = this.stuList[0]
					this.list()
				} else {
					this.searchParams.snm = null
					this.listData = {};

				}
			})
		},
		comfirmSub() {
			this.sbname = this.subData.name;
			this.searchParams.sbid = this.subData.id;
			this.page.current = 1
			this.list();
			this.dialogVisible = false;
		},
		treeClick(data) {
			this.subData = data;
		},
		//获取科目
		selectSub() {
			//if (this.permissionList == [] || this.permissionList.length == 0) {
			let param = {}
			if (this.searchParams.snm) {
				param.sname = this.searchParams.snm
			} else if (this.searchParams.clz) {
				param.cname = this.searchParams.clz
			}

			subApi.list(param, (response) => {
				this.permissionList = response.data;
			});
			//}
			this.dialogVisible = true;
		},
		//获取答题数据
		list() {

			if (this.searchParams.tnm * 1 == 1) {
				this.getOption(this.searchParams.clz)

			} else {
				this.listLoading = true;
				this.isAddon = false
				//console.log("this.isAddon = false")
				let params = this.$utils.merger(this.searchParams, this.page);

				if (this.searchParams.clz) {
					this.$caches.dftClzNm.set(this.searchParams.clz);
				} else {
					this.$caches.dftClzNm.remove();
				}
				params.isSort = this.isSortByScore

				api.list(params, response => {
					let val = response.data;
					this.judgeType(val);
					this.listLoading = false;
					// console.log(response);	
				})
			}

		}, getOption(clznm) {


			api.cntSubScore({ clznm: clznm, stunm: this.searchParams.snm }, res => {

				this.option.title.text = '课程模块成绩分布图'

				this.option.yAxis.data = res.data.yAxisData
				this.option.series[0].data = res.data.seriesData

				this.option.series[0].name = "统计样本（只取最后一次）" + res.data.cntAll+ " / "+res.data.cntAll2
				this.kidList = res.data.kidList
				this.echart1 = {}
				let rpt1 = document.getElementById("rpt1")
				this.echart1 = echarts.init(rpt1)

				this.echart1.setOption(this.option)
				let that = this

				if (!this.isAddon) {
					this.echart1.on('click', function (params) {
						if (params.value && that.option.title.text == '课程模块成绩分布图') {
						
							let kid = that.kidList[params.dataIndex]
							api.cntSubScore({ clznm: clznm, stunm: that.searchParams.snm, kid: kid }, res2 => {

								that.option.yAxis.data = res2.data.yAxisData

								that.option.title.text = that.option.yAxis.data[0].substring(0, that.option.yAxis.data[0].indexOf("[")) + ' ~ 子科目成绩分布图'

								that.option.series[0].data = res2.data.seriesData

								that.option.series[0].name = "统计样本（只取最后一次）" + res2.data.cntAll+ " / "+res2.data.cntAll2
	                                          console.log("成绩分布图",res2.data.cntAll,res2.data.cntAll2)
								//that.echart1 = echarts.init(document.getElementById("rpt1"))
								that.echart1.setOption(that.option)
							})
						} else {
						
							//back
							api.cntSubScore({ clznm: clznm, stunm: that.searchParams.snm }, res2 => {
								that.option.title.text = '课程模块成绩分布图'
								that.option.yAxis.data = res2.data.yAxisData
								that.option.series[0].data = res2.data.seriesData
								that.option.series[0].name = "统计样本（只取最后一次）" + res2.data.cntAll+ " / "+res2.data.cntAll2
									console.log("课程模块成绩分布图",res2.data.cntAll,res2.data.cntAll2)
								that.kidList = res2.data.kidList
								//that.echart1 = echarts.init(document.getElementById("rpt1"))
								that.echart1.setOption(that.option)
							})
						}
					});
					this.isAddon = true
				}




			})



		},
		// 处理分组排序的变更
		handleGroupOrderSort() {
			if (this.searchParams.tnm == 2 && this.listData.records) {
				if (this.isSortByGroupOrder) {
					// 加载exampaper数据后再进行排序
					this.loadExampaperDataForSorting().then(() => {
						this.sortedListData = this.sortByGroupOrder(this.listData.records);
					});
				} else {
					this.sortedListData = [...this.listData.records];
				}
			}
		},
		// 判断题型
		judgeType(val) {
			// 查看做的试卷统计
			if (val && this.searchParams.tnm < 2) {
				for (let i = 0; i < val.records.length; i++) {
					// 保存原始类型，以便getTypeName方法可以正确处理
					if (typeof val.records[i].type === 'number' || typeof val.records[i].type === 'string') {
						val.records[i].originalType = val.records[i].type;
						// 统一转换为数字进行比较
						const typeNum = parseInt(val.records[i].type);
						if (typeNum == 1) {
							val.records[i].type = "单选题"
						} else if (typeNum == 2) {
							val.records[i].type = "多选题"
						} else if (typeNum == 3) {
							val.records[i].type = "判断题"
						} else if (typeNum == 4) {
							val.records[i].type = "填空题"
						} else if (typeNum == 5) {
							val.records[i].type = "简答题"
						} else if (typeNum == 6) {
							val.records[i].type = "论述题"
						} else if (typeNum == 7) {
							val.records[i].type = "编程题"
						} else if (typeNum == 8) {
							val.records[i].type = "问答题"
						}
					}
				}
			}
			this.listData = val;

			// 添加调试信息
			//console.log('列表数据:', this.listData);

			if (this.searchParams.tnm == 2 && this.listData.records) {
				// 首先加载exampaper数据
				this.loadExampaperDataForSorting().then(() => {
					if (this.isSortByGroupOrder) {
						this.sortedListData = this.sortByGroupOrder(this.listData.records);
					} else {
						// 如果不需要分组排序，则直接使用原始数据
						this.sortedListData = [...this.listData.records];
					}
				});
			}
		}, toBukao() {
			this.bukao = { duration: 120 }
			this.dialogVisible2 = true
		}, comfirmBuKao() {
			//封装
			if (this.selected && this.selected.length > 0) {
				this.bukao.qids = this.selected
				this.bukao.snm = this.searchParams.snm
				this.bukao.starttime = this.bukaoTm[0]
				this.bukao.endtime = this.bukaoTm[1]

				apiExm.bukao(this.bukao, res => {
					this.dialogVisible2 = false
					this.$utils.msg.success(res.msg);
				}, err => {
					this.$utils.msg.warning(err.msg);
				})
			} else {
				this.$utils.msg.warning("没有选择补考的题，请确认");
			}

		},
		//清空搜索框
		clearSearchVal() {
			if(this.searchParams.sbid){
                      delete this.searchParams.sbid
			    this.sbname = undefined
			}
			
			this.searchParams.isSort = false
			this.searchParams.size = 10
			this.page.current = 1
			this.searchParams.tnm = 0
			this.list();
		},
		//改变选择项
		selectionChange(val) {
			//console.log("selectionChange(val)", val)
			//清空
			this.selected = [];
			this.msg = null;
			for (let item of val) {
				this.selected.push(item.qid);
			}

			this.msg = this.selected.length + " 题~被选中"
		},
		//去详情
		toDetail(index, row) {
			this.$refs.edit.open(row, '详情 - ' + row.type);
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		}, getTypeName(type) {
			if (typeof type === 'string' && isNaN(parseInt(type))) {
				return type;
			}

			const typeNum = parseInt(type);
			switch (typeNum) {
				case 1: return "单选题";
				case 2: return "多选题";
				case 3: return "判断题";
				case 4: return "填空题";
				case 5: return "简答题";
				case 6: return "论述题";
				case 7: return "编程题";
				case 8: return "问答题";
				default: return type;
			}
		}, handleStuSelect(value) {
			// 当用户直接从下拉框选择学生时，更新stuIdx
			if (this.stuList && this.stuList.length > 0) {
				let idx = this.stuList.indexOf(value);
				if (idx !== -1) {
					this.stuIdx = idx;
				}
			}
			this.page.current = 1
			this.list();
		},

		// 加载exampaper数据用于排序
		loadExampaperDataForSorting() {
			return new Promise((resolve) => {
				// 收集所有需要加载的试卷ID（注意是expid，不是id）
				const expIds = [];
				if (this.listData.records) {
					this.listData.records.forEach((record, index) => {
						// 使用expid字段而不是id字段
						const expId = record.expid;
						if (expId && !this.exampaperDataMap.has(expId)) {
							expIds.push(expId);
						}
					});
				}
				// 如果没有需要加载的ID，直接resolve
				if (expIds.length === 0) {
					resolve();
					return;
				}

				apiCour.listWithCourse({ ids: expIds.join(',') }, response => {
					// 将获取到的数据存入map中
					if (response.data && response.data.records) {
						//.log("test:" + response)
						response.data.records.forEach(exampaper => {
							// 使用试卷ID作为键
							this.exampaperDataMap.set(exampaper.id, exampaper);

							// 如果有sub_id，则提取科目ID并获取科目名称
							if (exampaper.courseInfo && exampaper.courseInfo.subId) {
								const subId = exampaper.courseInfo.subId;
								// 获取前9位作为科目ID
								const subjectId = subId.substring(0, 9);
								// 如果还没有该科目名称，则获取它
								if (!this.subjectNameMap.has(subjectId)) {
									this.loadSubjectName(subjectId);
								}
							}
						});
					} else {
					}
					resolve();
				}, error => {
					resolve();
				});
			});
		},
		// 排序方法
		sortByGroupOrder(data) {

			const sortedData = [...data];
		//	console.log("sortedData:" + sortedData)

			sortedData.sort((a, b) => {

			//	console.log(a)
				const subIdA = a.subId || '';
			//	console.log(subIdA)
				const subIdB = b.subId || '';

				if (!subIdA && !subIdB) return 0;
				if (!subIdA) return 1;
				if (!subIdB) return -1;

				const partsA = this.parseSubId(subIdA);
				const partsB = this.parseSubId(subIdB);
				if (partsA.moduleId !== partsB.moduleId) {
					const result = parseInt(partsA.moduleId) - parseInt(partsB.moduleId);
					return result;
				}
				if (partsA.subjectId !== partsB.subjectId) {
					const result = parseInt(partsA.subjectId) - parseInt(partsB.subjectId);
					return result;
				}
				const result = parseInt(partsA.paperIndex) - parseInt(partsB.paperIndex);
				return result;
			});
			return sortedData;
		},

		parseSubId(subId) {
			if (!subId) {
				return {
					moduleId: '00000',
					subjectId: '0000',
					paperIndex: '00'
				};
			}

			const subIdStr = subId.toString();
			if (subIdStr.length === 11) {
				const result = {
					moduleId: subIdStr.substring(0, 5),     // 前5位是模块ID
					subjectId: subIdStr.substring(5, 9),    // 中间4位是科目ID
					paperIndex: subIdStr.substring(9, 11)   // 最后2位是试卷序号
				};
				return result;
			}

			if (subIdStr.length === 10) {
				const result = {
					moduleId: subIdStr.substring(0, 5),     // 前5位是模块ID
					subjectId: subIdStr.substring(5, 8),    // 中间3位是科目ID
					paperIndex: subIdStr.substring(8, 10)   // 最后2位是试卷序号
				};
				return result;
			}
			return {
				moduleId: '00000',
				subjectId: '0000',
				paperIndex: '00'
			};
		},
		// 根据科目ID获取科目名称
		loadSubjectName(subjectId) {
			// 调用API获取科目名称
			subApi.toUpdate({ id: subjectId }, response => {
				if (response.data && response.data.name) {
					this.subjectNameMap.set(subjectId, response.data.name);
					this.$forceUpdate();
				}
			}, error => {
				console.log("没有科目名称");
			});
		},

		// 获取行的科目名称
		getSubjectName(subId) {
			if (!subId) return '';
			const subjectId = subId.substring(0, 9);
			if (this.subjectNameMap.has(subjectId)) {
				return this.subjectNameMap.get(subjectId);
			}
			this.loadSubjectName(subjectId);
		},

	},

	mounted() {

		if (!this.clzList) {
			//加载一个
			apiClazz.listNoEnd(null, res => {
				this.clzList = res.data
				//尝试前段缓存取   dftClzNm
				let dftClzNm = this.$caches.dftClzNm.get("dftClzNm");
				if (dftClzNm) {
					this.$set(this.searchParams, 'clz', dftClzNm)
					this.loadStu()
				}
			})

		}

		//this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
